/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Features_Closing_CtaInputs */

const en_portal_features_closing_cta = /** @type {(inputs: Portal_Features_Closing_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find a coach`)
};

const pl_portal_features_closing_cta = /** @type {(inputs: Portal_Features_Closing_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Znajdź trenera`)
};

/**
* | output |
* | --- |
* | "Find a coach" |
*
* @param {Portal_Features_Closing_CtaInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_features_closing_cta = /** @type {((inputs?: Portal_Features_Closing_CtaInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Features_Closing_CtaInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_features_closing_cta(inputs)
	return en_portal_features_closing_cta(inputs)
});